const RoutesName = {
    home: "/",
    login: "/login",
    newOrLoad: "/new-or-load",
    modelPage: "/model-page",
    newSetup: "/new-setup",
    category: "/category/:slug*",
    preset: "/preset",
    import: "/import",
};
export default RoutesName;
